import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientInvoicesListView } from '~/components/ClientInvoicesListView/ClientInvoicesListView';
import { useLocaleKeys } from '~/i18n';
import { useClientInvoices } from '../../hooks/useClientInvoices';
export const GetIssuedInvoicesTabTID = (parentTestId)=>getTestIds(parentTestId);
export function IssuedInvoicesTab(param) {
    let { clientId } = param;
    const { IssuedInvoicesTabTestIds: TID } = useMemo(()=>GetIssuedInvoicesTabTID(), []);
    const { t: texts } = useLocaleKeys('pages.clientDetail.tabContent.issuedInvoices');
    const { invoices, isLoading } = useClientInvoices(clientId);
    if (!isLoading && invoices.length === 0) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: TID.Root(),
            children: /*#__PURE__*/ _jsx(Typography, {
                testId: TID.Empty(),
                skin: "secondary",
                children: texts.emptyMessage()
            })
        });
    }
    return /*#__PURE__*/ _jsx(Box, {
        testId: TID.Root(),
        width: "100%",
        children: /*#__PURE__*/ _jsx(Box, {
            testId: TID.ListView(),
            width: "100%",
            children: /*#__PURE__*/ _jsx(ClientInvoicesListView, {
                invoices: invoices,
                isLoading: isLoading,
                customerId: clientId,
                testId: TID.ListView()
            })
        })
    });
}
